import { createTheme, rem, type MantineColorsTuple } from '@mantine/core';

// DESIGN.md 원시 토큰 — 컴포넌트에서 theme.other 또는 이 상수로 참조한다.
export const tokens = {
  surface: {
    base: '#0B0B0C',
    surface: '#131316',
    band: '#1A1A1E',
    elevated: '#202024',
    hover: '#26262B',
  },
  border: {
    default: '#2A2A30',
    strong: '#3A3A42',
  },
  text: {
    hi: '#F4F3F1',
    mid: '#9A9894',
    lo: '#63615C',
  },
  accent: {
    main: '#FF6A1F',
    bright: '#FF8A3D',
    soft: 'rgba(255,106,31,0.12)',
    line: 'rgba(255,106,31,0.4)',
  },
  semantic: {
    pos: '#46D08A',
    neg: '#FF6060',
    warning: '#E0B341',
  },
} as const;

// 네온 오렌지 ramp — index 6 = accent main (primaryShade)
const accent: MantineColorsTuple = [
  '#FFF0E6',
  '#FFE0CC',
  '#FFC09A',
  '#FF9F66',
  '#FF8A3D', // bright
  '#FF7A2B',
  '#FF6A1F', // main (primaryShade 6)
  '#E55A15',
  '#C24A10',
  '#9E3A0B',
];

// 표면 5단계 → Mantine dark 팔레트. dark[7] = body 배경(base).
const dark: MantineColorsTuple = [
  tokens.text.hi, // 0 hi text
  '#C9C7C3', // 1
  tokens.text.mid, // 2 dimmed text
  tokens.text.lo, // 3 placeholder
  tokens.border.default, // 4 border
  tokens.surface.elevated, // 5 elevated controls
  tokens.surface.surface, // 6 card/input 기본 배경
  tokens.surface.base, // 7 body 배경
  '#070708', // 8
  '#000000', // 9
];

export const theme = createTheme({
  primaryColor: 'accent',
  primaryShade: 6,
  autoContrast: true,
  colors: { accent, dark },
  fontFamily: 'Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: 'Geist Mono, ui-monospace, SFMono-Regular, monospace',
  headings: {
    fontFamily: 'Space Grotesk, Geist, sans-serif',
    fontWeight: '600',
    sizes: {
      h1: { fontSize: rem(30), fontWeight: '600', lineHeight: '1.25' },
      h2: { fontSize: rem(21), fontWeight: '600', lineHeight: '1.3' },
      h3: { fontSize: rem(17), fontWeight: '600', lineHeight: '1.35' },
    },
  },
  fontSizes: {
    xs: rem(13),
    sm: rem(14),
    md: rem(15), // Body
    lg: rem(17),
    xl: rem(21),
  },
  radius: {
    xs: rem(6),
    sm: rem(9),
    md: rem(10),
    lg: rem(14),
    xl: rem(16),
  },
  defaultRadius: 'md',
  spacing: {
    xs: rem(8),
    sm: rem(12),
    md: rem(16),
    lg: rem(24),
    xl: rem(32),
  },
  other: tokens,
});
